export enum AuthStatus {
  Idle = 'Idle',
  Loading = 'Loading',
  Succeeded = 'Succeeded',
  Failed = 'Failed',
}

export type LoginDetails = {
  email: string
  password: string
  remember: boolean
}

export type LoginErrorCode = 'Unauthorized' | 'Unknown' | 'Input'

export type LoginError =
  | {
      code: LoginErrorCode
    }
  | {
      code: 'Custom'
      message: string
    }

// A successful login resolves to the token string, otherwise an error object
export type LoginResponse = string | LoginError

export type LoginRequest = (details: LoginDetails) => LoginResponse | Promise<LoginResponse>
